import moment from "moment";

export const formatDayOfWeek = date => {
  return moment(date).format("dd").substr(0, 1);
};

export const isDateBefore = (dateA, dateB) =>
  dateA ? new Date(dateA) < new Date(dateB) : false;
